import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { StarsDeliveryService } from './service/stars-delivery.service';
import { debounceTime, distinctUntilChanged, finalize, shareReplay, takeUntil } from 'rxjs';
import { StarsDeliveryResponse } from './interfaces/stars-delivery.interface';

@Component({
  selector: 'stars-delivery',
  imports: [CommonModule],
  template: `
    <div class="flex items-center space-x-4 p-4">
      <!-- Información del delivery -->
      <div class="flex-1">


        <!-- Estrellas de calificación -->
        <div class="flex items-center space-x-1 mb-2">
          <span class="text-sm text-gray-600 mr-2">Calificación:</span>
          <div class="flex">
            @for (star of [1,2,3,4,5]; track star) {
              <i
                [class]="getStarClass(star)"
                class="text-lg">
              </i>
            }
          </div>
          <span class="text-sm text-gray-600 ml-2">({{ deliveryData()?.startEnd || 0 }}/5)</span>
        </div>

        <!-- Número de pedidos -->
        <div class="flex items-center space-x-2">
          <span class="text-sm text-gray-600">Pedidos completados:</span>
          <span class="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full">
            <i class="fas fa-box mr-1"></i>
            {{ deliveryData()?.quantityOrders || 0 }}
          </span>
        </div>
      </div>
    </div>
  `,
  styleUrl: './starsDelivery.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarsDeliveryComponent implements OnChanges {
  @Input() idDelivery: number = 0;
  stars = signal(0);
  deliveryData = signal<any>(null);
  constructor(private starsDeliveryService: StarsDeliveryService,
    private cdr: ChangeDetectorRef
  ) {

  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idDelivery']) {
      this.loadStarsDelivery();
    }
  }
  loadStarsDelivery() {
    // Validar que el ID sea válido antes de hacer la llamada
    if (!this.idDelivery || this.idDelivery <= 0) {
      // console.log('ID de delivery inválido:', this.idDelivery);
      return;
    }

    // console.log('Cargando datos para delivery ID:', this.idDelivery);
    this.starsDeliveryService.loadStarsDelivery(this.idDelivery).pipe(
      debounceTime(300), // Espera 300ms después del último cambio
      distinctUntilChanged(), // Solo emite si el valor es diferente al anterior
      finalize(() => {
        this.cdr.markForCheck();
      })).subscribe({
      next: (response: StarsDeliveryResponse) => {
        // console.log('respuesta ', response);
        if (response.status && response.data && response.data.length > 0) {
          this.deliveryData.set(response.data[0]);
          this.stars.set(response.data[0].startEnd);
        }
      }
    })
  }

  getStarClass(starNumber: number): string {
    const rating = this.deliveryData()?.startEnd || 0;
    if (starNumber <= rating) {
      return 'fas fa-star text-yellow-400';
    } else {
      return 'far fa-star text-gray-300';
    }
  }
}
